 import React, { useState } from 'react';

 import * as PropTypes from "prop-types";

  import {Icon} from "@iconify/react";
 import {Link} from "react-router-dom";

 export default function Engagements({ data,socialData }) {
  const { title, description,imgSrc,btnText,btnUrl } = data;



  return (
    <>
      <section className="project-section mt-4 text-white gray-bg" id="engagements">
        <div className="container">
          <div className="row align-items-center justify-content-center gy-5">
              <div
                  className="col-lg-8 col-xl-8"
                  data-aos="fade-right"
                  data-aos-duration="1200"
                  data-aos-delay="500"
              >
                  <div className="section-heading">
                      {title && (
                          <h6>
                              <span>{title}</span>
                          </h6>
                      )}

                  </div>
                  {description && <p className="textxl">{description}</p>}
                  <div className="btn-bar">
                      <a
                          href="https://wa.me/message/J6TRLFBX3I4VB1"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="px-btn"
                      >

                          BECOME RESELLER
                          <i>
                              <Icon icon="bi:arrow-right"/>
                          </i> </a>
                  </div>


              </div>


              <div
                  className="col-lg-4 col-xl-4"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="500"
              >
                  <div className="about-banner text-center">
                      <img src={imgSrc} alt="Thumb"/>
              </div>
            </div>
          </div>

        </div>
      </section>

    </>
  );
}
